/**
 * Copyright(c) 2018, DeCurtis Corporation.All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * File name: store.js
 * Author   : DeCurtis Team
 * Creation Date: 01/08/18 3:00 AM
 *
 */

import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import initialState from './initialState'
import reducer from '../reducers'

function configureStore() {
  let preloadedState={}
  let enhancer = null
  if (process.env.NODE_ENV === 'production') {
    preloadedState = window.__REDUX_STATE__
      ? window.__REDUX_STATE__
      : initialState
    enhancer = applyMiddleware(thunk)
  } else {
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    preloadedState = initialState
    enhancer = composeEnhancers(applyMiddleware(thunk))
  }
  return createStore(reducer, preloadedState, enhancer)
}

export default configureStore()
